import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, Platform } from '@ionic/angular';

import { isUndefined, toBoolean } from 'src/app/services/codeUtils';
import { emailMatchValidator, passwordMatchValidator, PASSWORD_PATTERN, mustBeTruthy, EMAIL_PATTERN } from 'src/app/services/customFormValidators';

import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { RewardsService } from 'src/app/services/rewards/rewards.service';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';
import { eMfaStatuses, UserSessionService } from 'src/app/services/user-session/user-session.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { MarketingService } from 'src/app/services/marketing/marketing.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ILoginRequestData, LoginResponseComments } from 'src/app/interfaces/authentication.interface';
import { BonusSelectorComponent } from 'src/app/components/bonus-selector/bonus-selector.component';
import { RoutingService } from 'src/app/services/routing/routing.service';

@Component({
  selector: 'app-signup-step-one',
  templateUrl: './signup-step-one.component.html',
  styleUrls: ['./signup-step-one.component.scss'],
})
export class SignupStepOneComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild(BonusSelectorComponent, { static: false }) bonusSelector: BonusSelectorComponent;
  @Input() signupcode: string;

  public termsSingupLinkTitle;
  public bonusCode;
  public error = null;
  public infoForm: FormGroup;
  public emailGroup: AbstractControl;
  public email: AbstractControl;
  public emailConfirm: AbstractControl;
  public passwordGroup: AbstractControl
  public password: AbstractControl;
  public passwordConfirm: AbstractControl;
  public certOver18: AbstractControl;
  public agreeAllTC: AbstractControl;
  public csrf_token: string = '';
  public registrationSuccessful: boolean = false;
  public buttonDisabled: boolean = false;
  public bonusIsVerified: boolean = false;
  public selectedBonusIndex;
  public customerAttributionData: any[];
  public extAffiliateId: string;
  public verifiedInputBonusCode: string;
  public welcomeOffers = [];
  public allowPromoEmailsCheck: boolean;
  public behalfSignupCheck: boolean;
  public allowPromoEmails: AbstractControl;
  public behalf: AbstractControl;
  public legalAge: number;
  public agreementProcess: boolean = true;
  public agreedCondition: boolean = false;
  public termsSingupLinkCode;

  public state_name;
  passwordConfirmOnStepOne: boolean;
  emailConfirmOnStepOne: boolean;
  certAndTCCombined: boolean;
  public isIos: boolean = false;

  constructor(
    private appLinksService: AppLinksService,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private eventsService: EventsService,
    private navigator: Navigator,
    private rewardService: RewardsService,
    public successMessageService: SuccessMessageService,
    private uniqueIDService: UniqueIDService,
    private userSessionService: UserSessionService,
    private marketingService: MarketingService,
    public utilsService: UtilsService,
    private platform: Platform,
    private routing: RoutingService,
  ) {
    this.agreementProcess = toBoolean(this.configService?.getConfig()?.FEATURE_TERMS_PRIVACY_AGREEMENT) ?? true;
    this.termsSingupLinkCode = this.configService.getConfig().FEATURE_TERMS_SINGUP_PAGE_CODE ?? 'signup-terms';
    this.termsSingupLinkTitle = this.configService?.getExternalLinks()?.payload?.filter(link => link?.code == this.termsSingupLinkCode)[0]?.title;

  }

  // get passwordGroup() {
  //   return this.infoForm.get('passwordGroup');
  // }

  get inputBonusCode() {
    return this.infoForm.get('inputBonusCode');
  }

  ngOnInit() {
    this.emailConfirmOnStepOne = this.configService.getConfig().FEATURE_EMAIL_CONFIRM_ON_STEP_ONE === '1' ? true : false;
    this.passwordConfirmOnStepOne = this.configService.getConfig().FEATURE_PASS_CONFIRM_ON_STEP_ONE === '1' ? true : false;
    this.certAndTCCombined = this.configService.getConfig().FEATURE_CERT_AND_TC_COMBINED_STEP_ONE === '1' ? true : false;
    this.legalAge = this.configService.getConfig().FEATURE_LEGAL_AGE ?? 21;
    this.allowPromoEmailsCheck = this.configService.getConfig().FEATURE_SIGNUP_SHOW_PROMO_FIELD === '1' ? true : false;
    this.behalfSignupCheck = this.configService.getConfig().FEATURE_SIGNUP_SHOW_BEHALF_FIELD === '1' ? true : false;
    this.infoForm = new FormGroup({
      clientapp: new FormControl(''),
      inputBonusCode: new FormControl(''),
      emailGroup: new FormGroup({
        email: new FormControl('', [Validators.pattern(EMAIL_PATTERN), Validators.required, Validators.maxLength(250)])
        // emailConfirm: new FormControl('', [Validators.pattern(EMAIL_PATTERN), Validators.required])
      },
        //  emailMatchValidator
      ),
      passwordGroup: new FormGroup({
        password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)])
        // passwordConfirm: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
      },
        //  passwordMatchValidator
      ),
      csrf: new FormControl(),
      certOver18: new FormControl(false, [mustBeTruthy]),
      // agreeAllTC: new FormControl(false, [mustBeTruthy]),
      customerAttributionData: new FormControl(''),
      extAffiliateId: new FormControl(''),
      allowPromoEmails: new FormControl(false),
      behalf: new FormControl(false),

    }
    );
    this.isIos = this.platform.is("ios");

    if (!this.certAndTCCombined) {
      this.infoForm.addControl('agreeAllTC', new FormControl(false, [mustBeTruthy]));
    }

    if (this.emailConfirmOnStepOne) {
      const emailGroup = this.infoForm.get('emailGroup') as FormGroup;
      emailGroup.addControl('emailConfirm', new FormControl('', [
        Validators.pattern(EMAIL_PATTERN),
        Validators.required
      ]));
      emailGroup.setValidators(emailMatchValidator);
    }
    if (this.passwordConfirmOnStepOne) {
      const passwordGroup = this.infoForm.get('passwordGroup') as FormGroup;
      passwordGroup.addControl('passwordConfirm', new FormControl('',
        [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]));
      passwordGroup.setValidators(passwordMatchValidator);
    }

    this.infoForm.get("clientapp").setValue(this.configService.getClientApp());

    this.emailGroup = this.infoForm.get('emailGroup');
    this.email = this.emailGroup.get('email');

    if (this.emailConfirmOnStepOne) {
      this.emailConfirm = this.emailGroup.get('emailConfirm');
    }

    this.passwordGroup = this.infoForm.get('passwordGroup');
    this.password = this.passwordGroup.get('password');

    if (this.passwordConfirmOnStepOne) {
      this.passwordConfirm = this.passwordGroup.get('passwordConfirm');
    }
    this.certOver18 = this.infoForm.get('certOver18');

    if (!this.certAndTCCombined) {
      this.agreeAllTC = this.infoForm.get('agreeAllTC');
    }
    //this.feautureCustomerSupportURL = this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL || '';

    if (this.allowPromoEmailsCheck) {
      this.allowPromoEmails = this.infoForm.get('allowPromoEmails');
    }
    if (this.behalfSignupCheck) {
      this.behalf = this.infoForm.get('behalf');
    }

    if (this.signupcode) {
      this.verifiedInputBonusCode = this.signupcode;
    }
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.generateCsrfToken();
  }

  generateCsrfToken() {
    this.authenticationService.getCsrfToken().subscribe(response => {
      if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
        this.infoForm.controls['csrf'].setValue(response.payload.token);
      }
    });
  }

  public setUpOffers(offers) {
    this.welcomeOffers = offers;
  }

  public selectBonus(event): void {
    if (typeof event === 'string') {
      this.bonusCode = event;
    } else {
      this.bonusCode = 'bonus' in event ? event.bonus : event.signupcode;
    }

    this.bonusIsVerified = this.bonusCode?.toUpperCase() === this.inputBonusCode?.value?.toUpperCase();
  }

  public onSubmit() {
    if (this.behalfSignupCheck) {
      if (this.behalf.value === true) {
        this.routing.defaultRoute();
        return this.showThirdPartyAlertError();
      } else {
        this.continueSingup();
      }
    } else {
      this.continueSingup();
    }
  }

  continueSingup() {

    if (this.inputBonusCode.value != "" && this.inputBonusCode.value != null) {
      if (this.bonusIsVerified) {
        this.bonusCode = this.inputBonusCode.value;
      } else {
        this.inputBonusCode.setErrors({ 'PROMO_CHECK': true });
        this.inputBonusCode.markAsTouched();
        this.inputBonusCode.markAsDirty();
        this.buttonDisabled = false;
        return false;
      }

    }

    if (this.certOver18.value === true && this.certAndTCCombined) {
      this.infoForm.addControl('agreeAllTC', new FormControl(false));
      this.agreeAllTC = this.infoForm.get('agreeAllTC');
      this.agreeAllTC.setValue(true);
    }

    this.infoForm.value["promo_code"] = this.bonusCode;
    if (typeof this.bonusCode == 'object' && this.bonusCode.bonus) {
      this.infoForm.value["promo_code"] = this.bonusCode.bonus;
    }
    this.authenticationService.callSignupStep1(this.infoForm.value).subscribe({
      next: (response: any) => {
        this.buttonDisabled = false;
        if (response && !!response.result) {

          if (response.result == 1) {
            const customer_id = response.payload.customerId;
            const csrf_token = (response.payload.csrf_token) ? response.payload.csrf_token : 'override';
            const obj: ILoginRequestData = { csrf: csrf_token, username: this.email.value, password: this.password.value, clientapp: this.configService.getClientApp() };

            this.authenticationService.callLogin(obj).subscribe({
              next: (response) => {
                if (response && !!response.result) {
                  this.userSessionService.setSessionToken(response.payload.sessionToken);

                  const loginInfo = response.payload
                  if (loginInfo?.comments?.indexOf(LoginResponseComments.CUSTOMER_MFA_REQUIRED) > -1) {
                    this.userSessionService.setMFAStatus(eMfaStatuses.required);
                    this.userSessionService.setLoginResponseForMFA();
                    if (loginInfo.deviceId) {
                      this.uniqueIDService.setMFADeviceIdAsObservable(loginInfo.deviceId);
                    }
                  }

                  if (!isUndefined(response.payload.customerId)) {
                    this.userSessionService.setCustomerId(response.payload.customerId);
                    this.userSessionService.setUserStatus({
                      customerId: response.payload.customerId,
                      sessionToken: response.payload.sessionToken
                    })
                  }
                  this.updateAffiliateData(customer_id);
                  this.userSessionService.refreshCustomer().subscribe(() => {
                    //Navigator.toLobby();
                    this.navigator.dismissAll();
                    //this.eventsService.publish('action:changeTab', 'CASINO');
                    this.eventsService.publish("event:appInit:init");
                  });

                  // event for successful signup
                  this.eventsService.publish('event:signupstep1complete', { customer_id: customer_id });
                }
              },
              error: (error) => {
                this.generateCsrfToken();
                switch (error.getErrorCode().toUpperCase()) {
                  case 'CUSTOMER_SUSPENDED':
                    error.setErrorMessage('Your account has been temporarily suspended. Please contact support.');
                    break;
                }
                this.eventsService.publish("event:login:error", { errorCode: error.getErrorCode().toUpperCase(), errorName: error.getErrorMessage() });
                // pass error object to page
                this.error = error;
                this.content.scrollToTop(10);
              }
            });
          } else {
            this.registrationSuccessful = false;
          }
        }
      },
      error: (error) => {
        this.buttonDisabled = false;
        console.error("callSignup error = ", error);

        this.generateCsrfToken();

        switch (error.getErrorCode().toUpperCase()) {
          case 'EMAIL_ALREADY_EXISTS':
            this.email.setErrors({ 'EMAIL_ALREADY_EXISTS': true });
            if (this.emailConfirmOnStepOne) {
              this.emailConfirm.setErrors({ 'EMAIL_ALREADY_EXISTS': true });
            }
            this.emailGroup.setErrors({ 'EMAIL_ALREADY_EXISTS': true });
            this.emailGroup.markAsTouched();
            this.emailGroup.markAsDirty();
            error.setErrorMessage("Form has errors, Please see below.");
            break;
          case 'ALREADY_HAS_ACCOUNT':
            error.setErrorMessage('It appears this account has already been created.');
            break;
          case 'CUSTOMER_IN_BLACKLIST':
            error.setErrorMessage('Cannot create account please contact customer support.');
            break;
          case 'GOVERNMENT_ID_ALREADY_EXISTS':
            error.setErrorMessage('Cannot create account please verify your data. Contact support if the issue continues.');
            break;
          case "PHONE_ALREADY_EXISTS":
            error.setErrorMessage("Something went wrong. Please try again or contact customer support.");
            break;
          default:
            error.setErrorMessage("Something went wrong. Please try again or contact customer support.");
            break;

        }
        this.error = error;
        this.content.scrollToTop(10);
      }
    });
  }

  public openMatchedExternalLinks(code, title) {
    return this.appLinksService.openMatchedExternalLinksPopover(code, title)
  }

  protected startAgreementProcess(c: string): any {
    const data: any = {
      accept: this.agreementComplete,
      decline: this.agreementInComplete,
      code: c,
      closePopover: this.closeAgreementPopover,
    }

    return this.navigator.openPopover(
      'PopoverAgreementComponent',
      data,
      this.platform.is('mobile') ? "standard-popover signup-agreement" : "standard-popover",
      false
    );
  }

  protected agreementComplete = () => {
    this.agreedCondition = true;
    this.agreeAllTC.setValue(true);
  }

  protected agreementInComplete = () => {
    this.agreedCondition = false;
    this.agreeAllTC.setValue(false);
  }

  protected closeAgreementPopover = () => {
    this.agreeAllTC.setValue(false)
  }

  protected termsPrivacyCheckChanged(e) {
    if (e.target.checked === true && !this.agreedCondition) {
      this.startAgreementProcess(this.termsSingupLinkCode);
    }
  }

  public bonusChanged() {
    if (this.inputBonusCode.value === '') {
      this.inputBonusCode.markAsPristine();
      this.inputBonusCode.setErrors({});
      this.infoForm.updateValueAndValidity();
      this.infoForm.enable();
    }
    else {
      this.bonusIsVerified = false;
    }
  }

  protected verifyBonus() {
    const bonusCode = this.inputBonusCode.value;

    if (bonusCode != null) this.authenticationService.validateReferrerCode(bonusCode).subscribe(
      response => {
        if ('result' in response && response.result == '1') {
          this.inputBonusCode.markAsPristine();
          this.inputBonusCode.markAsTouched();
          this.infoForm.markAsPristine();
          this.infoForm.markAsTouched();
          this.infoForm.updateValueAndValidity();
          this.infoForm.enable();
          this.error = '';

          this.checkIfPromoCampaign(bonusCode);
        }
      }, error => {
        this.verifiedInputBonusCode = '';
        const code: string = error?.error?.code || '';
        const errorCode = code?.toUpperCase();
        switch (errorCode) {
          case undefined:
            this.inputBonusCode.setErrors({ INVALID_PROMO: true });
            this.inputBonusCode.markAsTouched();
            this.inputBonusCode.markAsDirty();
            break;
          case 'INVALID_CODE':
            this.inputBonusCode.setErrors({ INVALID_PROMO: true });
            this.inputBonusCode.markAsTouched();
            this.inputBonusCode.markAsDirty();
            break;
          default:
            this.inputBonusCode.setErrors({ INVALID_PROMO: true });
            this.inputBonusCode.markAsTouched();
            this.inputBonusCode.markAsDirty();
        }
        this.bonusIsVerified = false;
      }
    );
  }

  protected checkIfPromoCampaign(bonusCode) {
    //check if bonus code is not null
    if (bonusCode != null && bonusCode != "") {
      return this.rewardService.callGetSignupOffer(bonusCode).subscribe({
        next: (response: any) => {
          if ('result' in response && response.result == "1") {
            this.addBonusToList(response.payload, bonusCode);
            this.content.scrollToTop();
          }
        },
        error: (error) => {
          //it's friend refferal
          console.log("error", error);
        }
      }).add(() => {
        //forcing to re-select value if already exists or friend refferal
        if (this.verifiedInputBonusCode == bonusCode) {
          this.verifiedInputBonusCode = '';
          this.verifyBonus();
        } else {
          this.verifiedInputBonusCode = bonusCode;
        }
      });
    }
  }

  protected addBonusToList(bonus, bonusCode) {
    if (this.welcomeOffers.findIndex(offer => (offer?.signupcode != null) ? offer?.signupcode?.toString()?.toUpperCase() === bonusCode?.toUpperCase() : null) === -1) {
      this.bonusSelector.addHiddenOffer(bonus);
    }
    this.selectedBonusIndex = this.welcomeOffers.findIndex(offer => (offer?.signupcode != null) ? offer?.signupcode?.toString()?.toUpperCase() === bonusCode?.toUpperCase() : null);
    this.selectBonus(this.welcomeOffers[this.selectedBonusIndex])
  }

  public updateAffiliateData(customer_id: string) {
    // get affiliate data
    this.marketingService.getAttributionData().then(data => {
      const customerUpdates: any = {};
      if (!data) {
        // look for appnexus data
        let appnexus_data: any = null;
        try {
          appnexus_data = JSON.parse(this.marketingService.getAppnexusData());
        } catch (e) { }
        if (!!appnexus_data && "undefined" !== typeof appnexus_data.extaffiliateid) {
          customerUpdates['extAffiliateId'] = appnexus_data.extaffiliateid;
        }
        if (!!appnexus_data) {
          customerUpdates['customerAttributionData'] = JSON.stringify(appnexus_data);
        } else {
          delete customerUpdates['customerAttributionData'];
        }
      }
      if (data) {
        try {
          if (typeof data === 'string') {
            data = JSON.parse(data);
          }

          this.customerAttributionData = data;

          if ("undefined" !== typeof data.affid) {
            this.extAffiliateId = data.affid;
          }

          if ("undefined" !== typeof data.affiliate) {
            this.extAffiliateId = data.affiliate;
          }
          if ("undefined" !== typeof data.ext_affiliate_id) {
            this.extAffiliateId = data.ext_affiliate_id;
          }

          if (this.utilsService.getInsensitiveProp(data, 'extAffiliateId')) {
            this.extAffiliateId = this.utilsService.getInsensitiveProp(data, 'extAffiliateId');
          }
        } catch (err) { }

        if ("undefined" !== typeof this.extAffiliateId) {
          customerUpdates['extAffiliateId'] = this.extAffiliateId;
        }
        if ("undefined" !== typeof this.customerAttributionData) {
          customerUpdates['customerAttributionData'] = JSON.stringify(this.customerAttributionData);
        }
      }
      const countKeys = (myobj) => {
        let count = 0;
        for (const k in myobj) if (Object.prototype.hasOwnProperty.call(myobj, k)) count++;
        return count;
      }
      if (countKeys(customerUpdates) > 0) {
        this.userSessionService.updateAccount(customer_id, customerUpdates);
      }
    });
  }

  protected onLogin() {
    return this.navigator.navigateTo('LoginComponent');
  }

  protected showMessage() {
    const hoverItem = document.getElementsByClassName('message-box');
    for (let i = 0; i < hoverItem.length; i++) {
      hoverItem[i].className = hoverItem[i].className.replace('message-box', 'message-box-visible');
    }
  }

  protected iconHoverEndEmitterFit() {
    const hoverItem = document.getElementsByClassName('message-box-visible');
    for (let i = 0; i < hoverItem.length; i++) {
      hoverItem[i].className = hoverItem[i].className.replace('message-box-visible', 'message-box');
    }
  }
  // Behalf Confirmation Popover
  behalfChanged() {
    if (this.behalf.value === false) {
      this.behalf.setValue(true);
      if (this.behalf.value === true) {
        const page = 'BehalfDeclarationPopover';
        const data = {
          title: 'Are you sure?',
          message: 'By ticking this box you\'re confirming that <b>you\'re creating this account on behalf of another person/party</b>.',
        }
        const behalfPopover = this.navigator.openPopover(
          page,
          data,
          'standard-popover levelup',
          true,
          true,
          true
        );
        behalfPopover.then(p => {
          p.onDidDismiss().then((res: any) => {
            this.buttonDisabled = false;
            if (res.data === 'no') {
              this.infoForm.get('behalf').setValue(false);
            }
            if (res.data === 'yes') {
              this.infoForm.get('behalf').setValue(true);
            }
          })
        })

      }
    }
  }

  showThirdPartyAlertError() {
    const data: any = {
      content: "We are unable to open your account as opening an account on behalf of a third party breaches our terms and conditions and is prohibited by the Alcohol and Gaming Commission of Ontario. Please contact customer service at 1-866-531-2600 if you think this is an error.",
    };
    this.navigator.openPopover(
      'PopoverAlertComponent',
      data,
      'standard-popover', false, true, true, -1, 'cover', true);
  }

  closeModal = () => {
    this.navigator.dismiss();
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }
}
